import type { FunctionComponent } from 'react'
import React, { useState } from 'react'
import { ButtonLink, Grid, GridItem, LinkButton, TypographyV2 as Typography } from '@which/seatbelt'
import { MinusIcon, PlusIcon } from '@which/seatbelt/src/components/Icons/Navigational'

import type { CaseView } from '../CheckSimilarAppointment/fetchSimilarCase'
import styles from './MyAppointment.module.scss'

export type MyAppointmentProps = {
  caseView: CaseView
  buttonText: string
  buttonLink: string
}

const mapCategory: Record<CaseView['category'], string> = {
  tech: 'Tech Support',
  money: 'Money',
  legal: 'Legal',
}

export const MyAppointment: FunctionComponent<MyAppointmentProps> = ({
  caseView,
  buttonText,
  buttonLink,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const startTime = new Date(caseView.appointment.startTime).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  })
  const endTime = new Date(caseView.appointment.endTime).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <div className={styles.myAppointment}>
      <Grid>
        <GridItem columnStart={{ medium: 1, xlarge: 1 }} span={{ large: 12, xlarge: 12 }}>
          <Typography tag="h4" textStyle="sb-text-heading-small">
            {caseView.title}
          </Typography>
          <Typography
            className={styles.myAppointmentRefNumber}
            textStyle="sb-text-body-small-regular"
          >
            Case reference number: {caseView.caseNumber}
          </Typography>
          <div className={styles.myAppointmentDetails}>
            <Typography
              className={styles.myAppointmentDetail}
              tag="span"
              textStyle="sb-text-body-default-regular"
            >
              {mapCategory[caseView.category]}
            </Typography>
            <Typography
              className={styles.myAppointmentDetail}
              tag="span"
              textStyle="sb-text-body-default-regular"
            >
              {new Date(caseView.appointment.startTime).toLocaleDateString('en-GB')}
            </Typography>
            <Typography
              className={styles.myAppointmentDetail}
              tag="span"
              textStyle="sb-text-body-default-regular"
            >
              {`${startTime}-${endTime}`}
            </Typography>
          </div>
        </GridItem>
        <GridItem
          className={styles.myAppointmentButtonContainer}
          columnStart={{ medium: 1, large: 1 }}
          span={{ large: 12, xlarge: 12 }}
        >
          <div>
            {caseView.description && (
              <LinkButton
                aria-atomic
                aria-pressed={isExpanded}
                data-testid="my-appointment-expand"
                icon={isExpanded ? MinusIcon : PlusIcon}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <Typography tag="span" textStyle="sb-text-interface-body-small-regular">
                  {isExpanded ? 'Hide description' : 'Show description'}
                </Typography>
              </LinkButton>
            )}
            <ButtonLink
              className={styles.myAppointmentButton}
              data-testid="my-appointment-btn-call"
              href={buttonLink}
            >
              {buttonText}
            </ButtonLink>
          </div>
          {isExpanded && caseView.description && (
            <Typography
              className={styles.myAppointmentDescription}
              textStyle="sb-text-body-default-regular"
            >
              {caseView.description}
            </Typography>
          )}
        </GridItem>
      </Grid>
    </div>
  )
}
